// src/utils/auth0Error.js
// Helpers pour détecter les erreurs Auth0 liées à l'expiration de session / refresh token

const extractPieces = (err) => {
  if (!err) return '';
  const parts = [
    err.error,
    err.code,
    err.error_description,
    err.message,
    err.original?.message,
    err.cause?.message,
    typeof err.toString === 'function' ? err.toString() : null,
  ];
  return parts
    .filter(Boolean)
    .map((p) => String(p).toLowerCase())
    .join(' | ');
};

const SESSION_REASON_TOKENS = [
  {
    reason: 'missing_refresh_token',
    tokens: ['missing_refresh_token', 'missing refresh token', '_f: missing refresh token'],
  },
  {
    reason: 'login_required',
    tokens: ['login_required', 'login required', 'session_missing'],
  },
  {
    reason: 'consent_required',
    tokens: ['consent_required', 'consent required'],
  },
  {
    reason: 'interaction_required',
    tokens: ['interaction_required'],
  },
  {
    reason: 'invalid_grant',
    tokens: ['invalid_grant'],
  },
];

export function classifyAuth0SessionError(err) {
  const haystack = extractPieces(err);
  if (!haystack) return null;
  for (const { reason, tokens } of SESSION_REASON_TOKENS) {
    if (tokens.some((token) => haystack.includes(token))) return reason;
  }
  return null;
}

export function isAuth0SessionExpiredError(err) {
  return !!classifyAuth0SessionError(err);
}

export function describeAuth0Error(err) {
  if (!err) return 'unknown_error';
  return extractPieces(err) || 'unknown_error';
}
